import React from "react";
import logo from "../../../assets/image/logo/eye.png";
import { ImCross } from "react-icons/im";
import { FaBars } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { cloudinaryBaseUrl } from "../../login/baseUrl";
import { LogoutApi } from "../../apifile/ApiFiles";
// import { toast, ToastContainer } from "react-toastify";
import { Dropdown } from "react-bootstrap";

const Header = ({ data, loginPageData, profileData }) => {
  const { sidebarActive, setSidebarActive } = data;
  const navigate = useNavigate()
  // const notify = (updateMassage) => toast(updateMassage);

  const logOut = async () => {
    try {
      const res = await LogoutApi()
      console.log(res);

      if (res?.data?.error == false) {
        // notify("Logout successfully");

        window.localStorage.removeItem('token')
        window.localStorage.removeItem('role')
        navigate('login')
        window.location.reload();
      }
      if (res?.status == 'fail') {
        // notify("Logout successfully");

        window.localStorage.removeItem('token')
        window.localStorage.removeItem('role')
        navigate('login')
        window.location.reload();
      }
    } catch (error) {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('role')
      navigate('login')
      window.location.reload();
    }

  }
  const defaultLogo = "https://www.abarissoftech.com/assets/img/logo-2.png";
  return (
    <>
      {/* <ToastContainer /> */}
      <header className="headerSec" >
        <div className="leftSide">
          <div className="logoPart">
            <Link to="/">
              <img
                src={
                  loginPageData?.data?.logo
                    ? `${cloudinaryBaseUrl}${loginPageData.data.logo}`
                    : ''
                }
                alt="Logo"
                className="img-fluid "
              />
            </Link>
          </div>
          {/* <div
            className="bar"
            onClick={() => {
              setSidebarActive(!sidebarActive);
            }}
          >
            {sidebarActive ? <FaBars /> : <ImCross />}
          </div> */}
        </div>
        <div className="rightSide">
          {/* <div className="dropdown">
            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Super Admin
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <Link className="dropdown-item" to="#">
                  My Profile
                </Link>
              </li>

              <li>
                <Link className="dropdown-item" to="login">
                  Login
                </Link>
              </li>
              <li>
                <button className="dropdown-item" onClick={logOut}>
                  Logout
                </button>
              </li>
            </ul>
          </div> */}

          <Dropdown>
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
              {profileData?.data?.role == 'user' ? `Welcome ${profileData?.data?.firstname}` : 'Super Admin'}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="admin/profile">
                My Profile
              </Dropdown.Item>
              {/* <Dropdown.Item as={Link} to="/login">
                Login
              </Dropdown.Item> */}
              <Dropdown.Item as="button" onClick={logOut}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>
    </>
  );
};

export default Header;
